import { GET_VENDORLIST_REQUESTED } from "resources/actionTypes";

export function getVendorsList(data) {
  return {
    type: GET_VENDORLIST_REQUESTED,
    payload: data
  };
}
